import React from 'react'
import {Popover, PopoverHeader, PopoverBody} from 'reactstrap'
import moment from 'moment'
import DayPicker, {DateUtils} from 'react-day-picker'
import _capitalize from 'lodash/capitalize'
import MomentLocaleUtils from 'react-day-picker/moment'
import 'moment/locale/ro'
import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/es'
export default class SelectPeriod extends React.Component {
    constructor(props) {
        super(props)
        const start_date_param = (moment(localStorage.getItem('start_date')) >= moment()) && localStorage.getItem('start_date')
        const start_date = moment(this.props.start_date || start_date_param || moment()).toDate()
        const end_date_param = (moment(localStorage.getItem('end_date')) > moment(start_date).add(2, 'days')) && localStorage.getItem('end_date')
        const end_date = moment(this.props.end_date || end_date_param || moment(start_date).add(2, 'days')).toDate()
        this.state = {
            from: start_date,
            to: end_date,
            pickOpen: false,
            dropOpen: false,
            locale: this.props.locale || 'en',
            months: window.innerWidth > 550 ? 2 : 1
        }
        moment.locale(this.props.locale || 'en')
    }

    togglePick = () => {
        this.setState({
            pickOpen: !this.state.pickOpen
        })
    }

    toggleDrop = () => {
        this.setState({
            dropOpen: !this.state.dropOpen
        })
    }

    validatePeriod = () => {
        const {from, to} = this.state
        return this.checkRange(from, to)
    }

    checkRange = (from, to) => {
        if (moment(to).startOf('day').diff(moment(from).startOf('day'), 'days') >= 1) {
            this.setState({hasError: false})
            return true
        }
        this.setState({hasError: true})
        return false
    }

    handleFromChange = (from) => {
        const to = moment.max(moment(from).add(2, 'days'), moment(this.state.to)).toDate()
        this.setState({from: from, to: to, enteredTo: undefined})
        this.togglePick()
        this.checkRange(from, to)
        localStorage.setItem('start_date', moment(from).format("YYYY-MM-DD"))
        localStorage.setItem('end_date', moment(to).format("YYYY-MM-DD"))
        // this.toggleDrop()
    }
    handleToChange = (to) => {
        this.setState({to: to, enteredTo: to})
        this.toggleDrop()
        this.checkRange(this.state.from, to)
        localStorage.setItem('end_date', moment(to).format("YYYY-MM-DD"))

    }

    isSelectingFirstDay = (from, to, day) => {
        const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from)
        return !from || isBeforeFirstDay
    }

    handleDayMouseEnter = (day) => {
        const {from, to} = this.state
        if (!this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                enteredTo: day
            })
        }
    }


    renderPick() {
        const {from, enteredTo} = this.state
        const modifiers = {start: from, end: enteredTo}
        return (
            <DayPicker
                selectedDays={[from]}
                disabledDays={{before: new Date()}}
                modifiers={modifiers}
                month={from}
                fromMonth={moment().toDate()}
                numberOfMonths={this.state.months}
                onDayClick={this.handleFromChange}
                locale={this.state.locale}
                localeUtils={MomentLocaleUtils}
            />
        )
    }

    renderDrop() {
        const {from, to, enteredTo} = this.state
        const modifiers = {start: from, end: enteredTo}
        return (
            <DayPicker
                selectedDays={[from, {from, to: enteredTo}]}
                disabledDays={{before: from}}
                modifiers={modifiers}
                month={to || from}
                fromMonth={from}
                numberOfMonths={this.state.months}
                onDayClick={this.handleToChange}
                onDayMouseEnter={this.handleDayMouseEnter}
                locale={this.state.locale}
                localeUtils={MomentLocaleUtils}
            />
        )
    }

    renderDate(date) {
        if(!date) return null
        return (
            <div className={'datePickDiv'}
                 style={this.state.hasError ? {'border': '1px solid red', 'background': '#fff6f6'} : {}}>
                <div className={'d-flex justify-content-between align-items-center'}>
                    <i className={'fa fa-calendar text-primary mr-2'}/>
                    <span>{_capitalize(moment(date).format('dddd'))}{', '}
                        <span className={'text-nowrap'}>
                            {moment(date).format('DD')}{' '}
                            {_capitalize(moment(date).format('MMMM'))}
                        </span>
                    </span>
                    <i className={'fa fa-angle-down ml-2'}/>
                </div>
            </div>
        )
    }


    render() {
        return (
            <div className={'row mb-3'}>
                <div className={'col-12 col-sm-6'}>
                    <small>{this.props.t.pick_date}</small>
                    <div id="Popover1" onClick={this.togglePick}>
                        {this.renderDate(this.state.from)}
                        <Popover placement="bottom-start" isOpen={this.state.pickOpen} target="Popover1"
                                 toggle={this.togglePick} trigger="legacy">
                            <PopoverHeader className={'bg-primary text-white text-center'}>
                                {this.props.t.pick_date}
                            </PopoverHeader>
                            <PopoverBody onClick={(e) => e.stopPropagation()}>
                                {this.renderPick()}
                            </PopoverBody>
                        </Popover>
                    </div>
                </div>
                <div className={'col-12 col-sm-6'}>
                    <small>{this.props.t.return_date}</small>
                    <div id="Popover2" onClick={this.toggleDrop}>
                        {this.renderDate(this.state.to)}
                        <Popover placement="bottom" isOpen={this.state.dropOpen} target="Popover2" toggle={this.toggleDrop} trigger="legacy">
                            <PopoverHeader className={'bg-primary text-white text-center'}>
                                {this.props.t.return_date}
                            </PopoverHeader>
                            <PopoverBody onClick={(e) => e.stopPropagation()} className={'InputFromTo'}>
                                {this.renderDrop()}
                            </PopoverBody>
                        </Popover>
                    </div>
                </div>
            </div>
        )
    }
}